import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { TOOLBAR_HEIGHT } from "../types/HeaderBar";

export const useAppBarHeight = () => {
    const theme = useTheme();
    const upSm = useMediaQuery(theme.breakpoints.up("sm"));

    return upSm ? TOOLBAR_HEIGHT.md : TOOLBAR_HEIGHT.sm;
};
